<template>
  <div class="customer-case main-container light-bg">

    <v-layout align-center class="grid grid-one blue-bg">
        <h3 class="display-3">Kundcase</h3>
        <p class="sub-headline">{{propheadline}}</p>
    </v-layout>
    <v-layout class="grid grid-two light-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
      <section class="grid-item">
        <img :src="image" class="image-above-text img-border grid-item-left-image">
      </section>
      <section class="grid-item">
        <h3 class="case-subheadline">"{{propsubheadline}}"</h3>
        <p>{{propdescription}}</p>
        <p><strong>Funktioner i lösningen:</strong></p>
        <p class="system-specs">{{propfunctions}}</p>
        <p><strong>Fördelar med lösningen:</strong></p>
        <p class="system-specs">{{propadvantages}}</p>
      </section>
    </v-layout>
    <!-- <div align-center class="light-bg">
      <section class="ccase-grid-item grid-one light-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
        <h3 class="sub-headline">"{{propsubheadline}}"</h3>
        <img :src="image" class="image-above-text img-border">
        <p>{{propdescription}}</p>
        <p><strong>Funktioner i lösningen:</strong></p>
        <p class="system-specs">{{propfunctions}}</p>
        <p><strong>Fördelar med lösningen:</strong></p>
        <p class="system-specs">{{propadvantages}}</p>
      </section>
    </div> -->

  </div>

</template>
<script>
    import { Component, Vue } from "vue-property-decorator";

    @Component({
        props: ['slug','headline','subheadline','image','description','advantages','functions'],
        data(){
            return {
              propslug: this.slug,
              propheadline: this.headline,
              propsubheadline: this.subheadline,
              propimage: this.image,
              propdescription: this.description,
              propadvantages: this.advantages,
              propfunctions: this.functions
            }
        },
        components: {},
        methods: {},
        beforeMount(){}
    })
    export default class SingelCase extends Vue {}
</script>
<style lang="scss" scoped>
.case-subheadline {
  font-size: 30px;
  margin-bottom: 30px;
}
 
</style>